import InviteGuest from './InviteGuest';
import PersonalizedInviteAdapterContainer from './PersonalizedInvite/PersonalizedInviteAdapter';
import PersonalizedInviteGenerator from './PersonalizedInvite/Generator';
import FacialRegistration from './PersonalizedInvite/components/FacialRegistration';
import SmartLockOpen from './SmartLockOpen';
import { INVITE_PATHS } from './constants';

export default [
  {
    name: 'Invite guest',
    path: '/guest',
    exact: true,
    component: InviteGuest,
  },
  {
    name: 'Invite guest smart lock',
    path: INVITE_PATHS.SMART_LOCK,
    exact: true,
    component: SmartLockOpen,
  },
  {
    name: 'Facial Registration',
    path: '/convite-personalizado/cadastro-facial',
    exact: true,
    component: FacialRegistration,
  },
  {
    name: 'Personalized Invite Generator',
    path: INVITE_PATHS.PERSONALIZED_INVITE_GENERATOR,
    exact: true,
    component: PersonalizedInviteGenerator,
  },
  {
    name: 'Personalized Invite',
    path: '/convite-personalizado',
    exact: true,
    component: PersonalizedInviteAdapterContainer,
  },
];
